<body>
  <app-nav-menu></app-nav-menu>
  <!-- <div class="container"> -->
  <router-outlet></router-outlet>
  <!-- </div> -->
  <!--<app-footer></app-footer>-->
  <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
</body>
